var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#E1251B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1256 19.8067L15.9575 22.6409C16.0634 22.7396 16.1484 22.8588 16.2073 22.9911C16.2662 23.1235 16.2979 23.2664 16.3005 23.4112C16.303 23.5561 16.2764 23.7 16.2222 23.8344C16.168 23.9687 16.0872 24.0908 15.9849 24.1932C15.8825 24.2957 15.7605 24.3765 15.6263 24.4307C15.4921 24.485 15.3483 24.5117 15.2035 24.5091C15.0587 24.5065 14.916 24.4748 14.7837 24.4159C14.6515 24.3569 14.5325 24.2719 14.4338 24.1658L9.76187 19.4902L9 18.7277L9.76187 17.9652L14.4338 13.2896C14.6381 13.099 14.9084 12.9952 15.1878 13.0002C15.4671 13.0051 15.7336 13.1183 15.9311 13.316C16.1286 13.5137 16.2418 13.7804 16.2467 14.06C16.2516 14.3395 16.1479 14.61 15.9575 14.8146L13.1256 17.6487H27.3281C28.5672 17.6487 29.7555 18.1413 30.6316 19.0182C31.5078 19.895 32 21.0843 32 22.3244C32 23.5644 31.5078 24.7537 30.6316 25.6305C29.7555 26.5074 28.5672 27 27.3281 27H24.4531C24.1672 27 23.893 26.8863 23.6908 26.684C23.4886 26.4816 23.375 26.2072 23.375 25.921C23.375 25.6348 23.4886 25.3604 23.6908 25.158C23.893 24.9557 24.1672 24.842 24.4531 24.842H27.3281C27.9953 24.842 28.6352 24.5768 29.1069 24.1046C29.5787 23.6325 29.8438 22.9921 29.8438 22.3244C29.8438 21.6566 29.5787 21.0163 29.1069 20.5441C28.6352 20.072 27.9953 19.8067 27.3281 19.8067H13.1256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconNew);
export default __webpack_public_path__ + "static/media/backIconNew.8881c72f02108d97e1aef95dc9787bb8.svg";
export { ForwardRef as ReactComponent };